// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ScheduledCallsInviteeItem__container-bb6a4e {
  min-height: 48px;
  display: flex;
  align-items: center;
}

.ScheduledCallsInviteeItem__avatar-fc6b37 {
  margin-inline-end: 8px;
}

.ScheduledCallsInviteeItem__group-name-c8cfdb {
  font: var(--font-body-4);
  letter-spacing: var(--font-spacing-body-4);
  color: var(--base-110);
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/Popups/ScheduledCalls/ScheduledCallViewPopup/ScheduledCallsInviteesList/ScheduledCallsInviteeItem/ScheduledCallsInviteeItem.styles.m.css"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;AACF;;AAEA;EACE,sBAAA;AACF;;AAEA;EACE,wBAAA;EACA,0CAAA;EACA,sBAAA;AACF","sourcesContent":[".container {\n  min-height: 48px;\n  display: flex;\n  align-items: center;\n}\n\n.avatar {\n  margin-inline-end: 8px;\n}\n\n.group-name {\n  font: var(--font-body-4);\n  letter-spacing: var(--font-spacing-body-4);\n  color: var(--base-110);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ScheduledCallsInviteeItem__container-bb6a4e`,
	"avatar": `ScheduledCallsInviteeItem__avatar-fc6b37`,
	"group-name": `ScheduledCallsInviteeItem__group-name-c8cfdb`,
	"groupName": `ScheduledCallsInviteeItem__group-name-c8cfdb`
};
module.exports = ___CSS_LOADER_EXPORT___;
